import { useLayoutEffect, useRef, useState, type RefObject } from 'react'

/**
 * Tracks an element's rendered width in px, re-measuring whenever it resizes.
 * Returns 0 until the first measurement.
 */
export const useElementWidth = <T extends HTMLElement = HTMLDivElement>(): [
  RefObject<T>,
  number
] => {
  const ref = useRef<T>(null)
  const [width, setWidth] = useState(0)

  useLayoutEffect(() => {
    const el = ref.current
    if (!el) {
      return
    }
    const measure = () => setWidth(el.getBoundingClientRect().width)
    measure()
    const observer = new ResizeObserver(measure)
    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  return [ref, width]
}
